import React from 'react';

import { AlertFloating } from '@flipdish/ui-library/components/molecules/Alert';
import { type Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'recompose';

// Match PageLayout `.container` horizontal margins so the alert lines up with the title.
const useStyles = makeStyles(({ spacing, breakpoints }: Theme) => ({
  root: {
    marginLeft: spacing(6),
    marginRight: spacing(4),
    [breakpoints.only('md')]: {
      marginLeft: 12,
      marginRight: spacing(3),
    },
    [breakpoints.only('sm')]: {
      marginLeft: spacing(3),
      marginRight: spacing(3),
    },
    [breakpoints.only('xs')]: {
      marginLeft: spacing(2),
      marginRight: spacing(2),
    },
  },
}));

type OwnProps = {
  onDismiss: () => void;
};

type Props = OwnProps & MappedState;

const InviteTeamAlert = (props: Props) => {
  const { appId, onDismiss, translate } = props;
  const history = useHistory();
  const classes = useStyles();

  const handleConfirm = () => {
    onDismiss();
    history.push(`/${appId}/settings/teammates`);
    // MFEs only re-read the URL on popstate, which history.push never fires.
    requestAnimationFrame(() => window.dispatchEvent(new PopStateEvent('popstate')));
  };

  return (
    <div data-tailwind className={clsx(classes.root, 'pt-3xl')}>
      <AlertFloating
        title={translate('Bring_your_team_on_board') as string}
        description={translate('Give_your_employees_access_they_need') as string}
        confirmLabel={translate('Add_users') as string}
        dismissLabel={translate('Not_now') as string}
        color="brand"
        onConfirm={handleConfirm}
        onClose={onDismiss}
      />
    </div>
  );
};

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => ({
  appId: state.currentApp.AppId!,
  translate: getTranslate(state.locale),
});

export default compose<Props, OwnProps>(connect(mapStateToProps))(InviteTeamAlert);
